module.exports = __webpack_public_path__ + "bin/f90a4a3862f59c1ab38bf6b49031f568.png";